import { Box, Typography } from '@mui/material'
import { Link } from '@assets-components'
import { Image, type ImageData } from '@media-components'
import { getStyles, type CustomStyles } from '@utils/styles'
import { ActionButton, type ActionButtonData } from '../ActionButton'
import { SectionWrapper } from '../SectionWrapper'
import defaultStyles, { type StylesClassNames } from './styles'

export type CostimizerBannerData = {
  actionButtonData?: ActionButtonData
  imageData?: ImageData
  heading?: string
  description?: string
}

export type CostimizerBannerProps = {
  csx?: CustomStyles<StylesClassNames>
} & CostimizerBannerData

export function CostimizerBanner({
  actionButtonData,
  imageData,
  heading,
  description,
  csx,
}: CostimizerBannerProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <SectionWrapper
      sx={{
        overflow: 'hidden',
      }}
      csx={{
        wrapper: {
          paddingTop: '1rem !important',
          paddingBottom: '0px !important',
        },
      }}
    >
      <Box {...styles('bannerWrapper')}>
        <Box {...styles('textWrapper')}>
          <Typography variant="h3.700" color="neutral.white">
            {heading}
          </Typography>
          <Typography
            variant="body1.500"
            color="neutral.white"
            sx={{ marginBottom: '0.5rem' }}
          >
            {description}
          </Typography>
          <ActionButton
            variant="contained"
            showArrow
            {...styles('actionButton')}
            {...actionButtonData}
          />
        </Box>
        <Box
          sx={{
            cursor: 'pointer',
          }}
          component={actionButtonData?.link ? Link : 'div'}
          {...(actionButtonData?.link && { href: actionButtonData.link })}
          target={actionButtonData?.link ? '_blank' : undefined}
        >
          {imageData && (
            <Image
              src={imageData.src}
              alt={imageData.alt}
              {...styles('imgStyle')}
            />
          )}
        </Box>
      </Box>
    </SectionWrapper>
  )
}
